<template>
  <transition appear name="fade">
    <div class="login-body row h-100">
      <form
        class="form-signin card align-middle p-4 my-auto"
        v-on:submit.prevent=""
      >
      <div v-if="logoSrc" class="text-center mb-2">
          <img :src="logoSrc" class="mb-2" />
          <p v-html="logoCopy" class="logo-copy"></p>
        </div>
        <!-- regular login -->
        <transition appear mode="out-in" name="fade">
          <div
            v-if="login"
            key="regular-login"
            class="login-card align-middle p-2"
          >
          <div class="d-flex justify-content-center mb-2 flex-column align-items-center">
            <h3 class="font-weight-bold">Login</h3>
            <p class="text-warning font-weight-bold text-center" style="color: #ff5b00 !important; font-size: 0.9rem;">
              ⚠ Please make sure there are no spaces before or after the username and password!
            </p>
          </div>
          <label>
            <input type="radio" v-model="loginMethod" value="password" /> Login with Password
          </label>
          <label>
            <input type="radio" v-model="loginMethod" value="otp" /> Login with OTP
          </label>
            <div class="form-label-group">
              <label for="inputUsername" style="font-weight:normal"
                >Username</label
              >
              <input
                id="inputUsername"
                v-model="username"
                autofocus
                v-on:focus="focused"
                class="form-control"
                placeholder="Username"
                type="text"
              />
              <p class="text-sm mt-1" style="color:red">{{ usernameError }}</p>
            </div>
            <div v-if="loginMethod === 'password'" class="form-label-group">
              <label for="InputPassword" style="font-weight:normal"
                >Password</label
              >
              <div
                class="form-control d-flex align-items-center p-0"
                id="passwordContainer"
                v-if="!showPassword"
              >
                <input
                  id="inputPassword"
                  v-model="password"
                  v-on:focus="focused"
                  class="form-control w-100"
                  placeholder="Password"
                  type="password"
                />
                <div
                  style="border:none;width: 20%;"
                  class="d-flex justify-content-center"
                  v-on:click="togglePassword"
                >
                  <span
                    ><font-awesome-icon icon="eye"></font-awesome-icon>
                  </span>
                </div>
              </div>
              <div
                class="form-control d-flex align-items-center p-0"
                id="passwordContainer"
                v-else
              >
                <input
                  id="inputPassword"
                  v-model="password"
                  v-on:focus="focused"
                  class="form-control w-100"
                  placeholder="Password"
                  type="text"
                />
                <div
                  style="border:none;width: 20%;"
                  class="d-flex justify-content-center"
                  v-on:click="togglePassword"
                >
                  <span
                    ><font-awesome-icon icon="eye-slash"></font-awesome-icon>
                  </span>
                </div>
              </div>
              <p class="text-sm mt-1" style="color:red">{{ passwordError }}</p>
            </div>
            <div
              class="mt-3 mb-2 small text-secondary font-weight-bold d-flex justify-content-between"
            >
              <div class="custom-control custom-checkbox mb-3">
                <input
                  id="save-info"
                  v-model="rememberMe"
                  class="custom-control-input"
                  type="checkbox"
                />
                <label
                  class="custom-control-label text-small text-dark"
                  for="save-info"
                  style="font-weight:normal"
                  >Remember me</label
                >
              </div>
              <a class="forgot-password" href="#" v-on:click="login = !login"
                >Forgot password?</a
              >
            </div>

            <button
              v-on:click="authenticate(username, password)"
              class="btn btn-dark d-inline-block w-100 btn-lg"
              tag="button"
            >
              Sign in
            </button>
          </div>
          <!-- forgot password  -->
          <div v-else key="lost-pwd" class="forgot-pass-card">
            <div>
              <h3>Forgot my password</h3>
              <p>
                Please enter your email address and your password will be sent
                to you.
              </p>
            </div>
            <div class="form-label-group">
              <input
                id="inputEmail"
                v-model="email"
                autofocus
                class="form-control"
                placeholder="your e-mail address"
                required
                type="email"
              />
            </div>
            <div class="mt-3 small text-secondary font-weight-bold">
              <button
                v-on:click="requestPasswordEmail(email)"
                class="btn btn-primary d-inline-block w-75 btn-lg"
              >
                Send me a new password
              </button>
              <a class="float-right my-2" href="#" v-on:click="login = !login"
                >Go back</a
              >
            </div>
          </div>
          <!-- forgot password -->
        </transition>
      </form>
    </div>
  </transition>
</template>

<script>
// TODO move these to "store"
const LOCALSTORAGE_USERNAME = "loginUsername";
const LOCALSTORAGE_REMEMBER_ME = "loginRememberMe";
const LOCALSTORAGE_STANDARD_UI_LOGO = "loginStandardUILogo";
const LOCALSTORAGE_STANDARD_UI_COPY = "loginStandardUICopy";
const LOCALSTORAGE_CUSTOM_UI_ID = "loginCustomUIID";

export default {
  name: "AdminLogin",
  data() {
    return {
      login: true,
      logoSrc: "",
      logoCopy: "Welcome to your points award program",
      username: "",
      password: "",
      email: "",
      rememberMe: false,
      usernameError: "",
      passwordError: "",
      showPassword: false,
      loginMethod: 'password'
    };
  },
  created() {
    if (localStorage.getItem(LOCALSTORAGE_USERNAME)) {
      this.username = localStorage.getItem(LOCALSTORAGE_USERNAME);
    }
    if (localStorage.getItem(LOCALSTORAGE_REMEMBER_ME)) {
      try {
        this.rememberMe = JSON.parse(
          localStorage.getItem(LOCALSTORAGE_REMEMBER_ME)
        );
      } catch (e) {
        localStorage.removeItem(LOCALSTORAGE_REMEMBER_ME);
      }
    }
    if (localStorage.getItem(LOCALSTORAGE_STANDARD_UI_LOGO)) {
      this.logoSrc = localStorage.getItem(LOCALSTORAGE_STANDARD_UI_LOGO);
    }
    // TODO use COOKIE_STANDARD_UI_COPY to set logoCopy. But only after the content in the DB is adapter (right now it's really big html and it looks horrible)
  },
  destroyed(){
    if(this.$route.name==='Home'){
      window.location.reload();
    }
  },
  methods: {
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
    authenticate: function(username, password) {
      this.$store
        .dispatch("auth/adminLogin", {
          username,
          password,
        })
        .then(
          () => {
            localStorage.setItem(
              LOCALSTORAGE_REMEMBER_ME,
              JSON.stringify(this.rememberMe)
            );
            localStorage.setItem(LOCALSTORAGE_USERNAME, username);
            // if (this.rememberMe) {
            //   localStorage.setItem(LOCALSTORAGE_USERNAME, username);
            // } else {
            //   localStorage.removeItem(LOCALSTORAGE_USERNAME);
            // }
            this.$store.dispatch("user/setIsDivvyAdmin", true);
            localStorage.setItem(LOCALSTORAGE_CUSTOM_UI_ID, "divvyAdmin");
            localStorage.setItem("isDivvyAdmin", true);
            //TODO get loginLogoSrc
            //TODO check custom-login using clientId
            this.$router.push({ name: "divvyAdminDashboard" });
          },
          (err) => {
            console.log(err);
            if (err.response.status === 403) {
              if (username.endsWith(" ")) {
                // Some users have had their usernames saved with an additional space at the end for years...
                this.authenticate(username.slice(0, -1), password);
              } else if (password.endsWith(" ")) {
                // Some users have had their passwords saved with an additional space at the end for years...
                this.authenticate(username, password.slice(0, -1));
              } else {
                this.showErrorBox("Incorrect user name and/or password");
              }
            } else {
              this.showErrorBox(err);
            }
          }
        )
        .catch((er) => {
          this.showErrorBox("Incorrect user name and/or password");
        });
    },
    focused() {
      var inputUsername = document.getElementById("inputUsername");
      inputUsername.classList.remove("error-box");
      this.usernameError = "";
      var inputPassword = document.getElementById("inputPassword");
      inputPassword.classList.remove("error-box-password");
      var passwordContainer = document.getElementById("passwordContainer");
      passwordContainer.classList.remove("error-box");
      this.passwordError = "";
    },
    showErrorBox: function(message) {
      if (this.username === "" && this.password === "") {
        var inputUsername = document.getElementById("inputUsername");
        inputUsername.classList.add("error-box");
        this.usernameError = "Username is required!";
        var inputPassword = document.getElementById("inputPassword");
        inputPassword.classList.add("error-box-password");
        var passwordContainer = document.getElementById("passwordContainer");
        passwordContainer.classList.add("error-box");
        this.passwordError = "Password is required!";
      } else if (this.username === "") {
        var inputUsername = document.getElementById("inputUsername");
        inputUsername.classList.add("error-box");
        this.usernameError = "Username is required!";
      } else if (this.password === "") {
        var inputPassword = document.getElementById("inputPassword");
        inputPassword.classList.add("error-box-password");
        var passwordContainer = document.getElementById("passwordContainer");
        passwordContainer.classList.add("error-box");
        this.passwordError = "Password is required!";
      } else {
        var inputUsername = document.getElementById("inputUsername");
        inputUsername.classList.add("error-box");
        var inputPassword = document.getElementById("inputPassword");
        inputPassword.classList.add("error-box-password");
        var passwordContainer = document.getElementById("passwordContainer");
        passwordContainer.classList.add("error-box");
        this.passwordError = message;
      }
    },
    requestPasswordEmail: function(email) {
      if (
        !/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/.test(
          email
        )
      ) {
        this.showError("Invalid email address");
        return;
      } else {
        this.$store.dispatch("auth/requestPasswordEmail", email).then(
        () => {
          this.showError("Please check your email inbox");
        },
        (err) => {
          this.showError("Unknown error");
        }
      );
      }
    },
    fetchCompany: function() {
      this.$store.dispatch("company/fetchCompany").then(() => {
        if (this.$store.state.company.logoUrl) {
          localStorage.setItem(
            LOCALSTORAGE_STANDARD_UI_LOGO,
            this.$store.state.company.logoUrl
          );
        } else {
          localStorage.removeItem(LOCALSTORAGE_STANDARD_UI_LOGO);
        }
        if (this.$store.state.company.loginCopyHtml) {
          localStorage.setItem(
            LOCALSTORAGE_STANDARD_UI_COPY,
            this.$store.state.company.loginCopyHtml
          );
        } else {
          localStorage.removeItem(LOCALSTORAGE_STANDARD_UI_COPY);
        }
        if (this.$store.state.company.customLoginId) {
          localStorage.setItem(
            LOCALSTORAGE_CUSTOM_UI_ID,
            this.$store.state.company.customLoginId
          );
        } else {
          localStorage.removeItem(LOCALSTORAGE_CUSTOM_UI_ID);
        }
      });
    },
    showError: function(message) {
      this.$bvModal.msgBoxOk(message, {
        size: "sm",
        headerClass: "p-2 border-bottom-0",
        footerClass: "p-2 border-top-0",
        centered: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
body {
  // background-image: url(../../assets/images/bg-5pct.svg);
  background-position: top center;
  background-repeat: repeat;
  background-size: 70px;
  background-color: #f5f5f5;
}
html,
body {
  height: 100%;
}
.login-body {
  align-items: center;
  width: 100%;
  background-color: $gray-900;
}
.error-box {
  border: 1px solid red;
}
.error-box-password{
  border-top:1px solid red;
  border-bottom: 1px solid red;
  border-radius: 5px 0px 0px 5px;
}
.error-text {
  color: red;
}
h3::after {
  content: none;
}
.logo-copy {
  font-weight: bold;
  color: black;
  font-size: 20px;
}
.form-signin {
  width: 100%;
  max-width: 430px;
  padding: 15px;
  margin: 10% auto;
  vertical-align: middle;
  img {
    max-width: 100%;
    max-height: 120px;
  }
  .form-label-group {
    position: relative;
    margin-bottom: 1rem;
  }
  #inputUsername,
  #inputPassword,
  #inputEmail {
    background-image: url(../../assets/icons/user-b.svg);
    background-repeat: no-repeat;
    background-position: 15px center;
    padding-left: 40px;
  }
  #inputPassword {
    background-image: url(../../assets/icons/lock-b.svg);
  }
  #inputEmail {
    background-image: url(../../assets/icons/mail-b.svg);
  }
}
@media all and (max-width: 480px) {
  .login-body {
    background-color: $white;
  }
}
.forgot-password{
  color:rgb(116, 115, 115);
}
</style>
